import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateAd, fetchAds } from '../../redux/features/adsSlice';

const AdDisplay = ({ type = 'banner', position = 'top' }) => {
    const dispatch = useDispatch();
    const { items: ads, status } = useSelector(state => state.ads);
    const [currentAd, setCurrentAd] = useState(null);
    useEffect(() => {
        dispatch(fetchAds());
    }, [dispatch]);
    useEffect(() => {
        // Filter ads by type, position, and active status
        console.log(`Filtering ads: type=${type}, position=${position}`);
        const filteredAds = ads.filter(ad =>
            ad.active &&
            ad.type === type &&
            ad.position === position
        );

        // If there are matching ads, select one randomly
        if (filteredAds.length > 0) {
            const randomAd = filteredAds[Math.floor(Math.random() * filteredAds.length)];
            setCurrentAd(randomAd);
            console.log(`Selected ad: ${randomAd.id} - ${randomAd.title}`);
            // Record impression
            dispatch(updateAd({
                id: randomAd.id,
                impressions: (randomAd.impressions || 0) + 1
            }));
        }
    }, [ads, type, position, dispatch]);

    const handleAdClick = () => {
        if (currentAd) {
            // Record click
            dispatch(updateAd({
                id: currentAd.id,
                clicks: (currentAd.clicks || 0) + 1
            }));

            // Open the link in a new tab
            if (currentAd.linkUrl) {
                window.open(currentAd.linkUrl, '_blank', 'noopener,noreferrer');
            }
        }
    };

    console.log(`Rendering ad: ${currentAd ? currentAd.id : 'null'}`);

    if (!currentAd) {
        // Return placeholder or null
        return (
            <div className="ad-placeholder border border-dashed border-white bg-white flex items-center justify-center p-4">
                <span className="text-xs text-white">Ad Space</span>
            </div>
        );
    }

    return (
        <div className={`ad-display mb-6 ${position === 'sidebar' ? 'min-h-[400px] flex flex-col' : ''}`} onClick={handleAdClick}>
            {currentAd.htmlContent ? (
                <div
                    className={`ad-custom-html ${position === 'sidebar' ? 'flex-grow' : ''}`}
                    dangerouslySetInnerHTML={{ __html: currentAd.htmlContent }}
                />
            ) : currentAd.imageUrl ? (
                <div className={`ad-image cursor-pointer ${position === 'sidebar' ? 'flex-grow' : ''}`}>
                    <img
                        src={currentAd.imageUrl}
                        alt={currentAd.title}
                        className={`${position === 'sidebar' ? 'h-full object-cover' : 'w-full h-auto object-contain'}`}
                    />
                    {currentAd.description && (
                        <p className="text-xs text-gray-500 mt-1">{currentAd.description}</p>
                    )}
                </div>
            ) : (
                <div className={`ad-text p-4 bg-gray-50 border border-gray-200 ${position === 'sidebar' ? 'flex-grow' : ''}`}>
                    {currentAd.title && <h4 className="font-bold">{currentAd.title}</h4>}
                    {currentAd.description && <p>{currentAd.description}</p>}
                </div>
            )}
            <div className="text-xs text-gray-400 text-right mt-1">Advertisement</div>
        </div>
    );
};

export default AdDisplay;
